import { atom, useAtom } from "jotai";

import { rfqDurations } from "#/config/orders";

export const rfqRequestDurationAtom = atom<number>(rfqDurations[0]);

export const useRfqRequestDuration = () => {
  const [rfqRequestDuration, setRfqRequestDuration] = useAtom(
    rfqRequestDurationAtom,
  );

  return {
    rfqRequestDuration,
    setRfqRequestDuration,
  };
};
